var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRulerAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear / Design, Tools / Ruler Angular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 9V27.75C3.5 29.8567 3.5 30.91 4.00559 31.6667C4.22447 31.9943 4.50572 32.2755 4.83329 32.4944C5.58996 33 6.64331 33 8.75 33C10.8567 33 11.91 33 12.6667 32.4944C12.9943 32.2755 13.2755 31.9943 13.4944 31.6667C14 30.91 14 29.8567 14 27.75V16.5C14 15.0858 14 14.3787 14.4393 13.9393C14.8787 13.5 15.5858 13.5 17 13.5H28.25C30.3567 13.5 31.41 13.5 32.1667 12.9944C32.4943 12.7755 32.7755 12.4943 32.9944 12.1667C33.5 11.41 33.5 10.3567 33.5 8.25C33.5 6.14331 33.5 5.08996 32.9944 4.33329C32.7755 4.00572 32.4943 3.72447 32.1667 3.50559C31.41 3 30.3567 3 28.25 3H9.5C6.67157 3 5.25736 3 4.37868 3.87868C3.5 4.75736 3.5 6.17157 3.5 9Z",
    stroke: "#D80587",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5 3L18.5 6M27.5 3L27.5 6M14 3L14 7.5M23 3L23 7.5",
    stroke: "#D80587",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.5 18H6.5M3.5 27H6.5M3.5 22.5L8 22.5M3.5 13.5L8 13.5",
    stroke: "#D80587",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerAngular);
export default __webpack_public_path__ + "static/media/ruler-angular.923fd9221acbc04ac449dffdcfe1baab.svg";
export { ForwardRef as ReactComponent };